if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.zoomButton = document.createElement('button');
        this.zoomButton.type = 'button';
        this.zoomButton.addEventListener('pointerup', (event) => event.stopPropagation());
        this.zoomButton.className = 'pups-media-zoom-toggle';
        this.zoomButton.textContent = 'Zoom in';
        this.zoomButton.setAttribute('aria-pressed', 'false');
        this.querySelector('[role="dialog"]').appendChild(this.zoomButton);
        this.zoomButton.addEventListener('click', (event) => {
          event.stopPropagation();
          const zoomed = this.classList.toggle('pups-media-zoomed');
          this.zoomButton.textContent = zoomed ? 'Fit image' : 'Zoom in';
          this.zoomButton.setAttribute('aria-pressed', String(zoomed));
          const container = this.querySelector('[role="document"]');
          const image = container.querySelector('img.active');
          container.scrollTop = 0;
          container.scrollLeft = zoomed && image ? Math.max(0, (image.offsetWidth - container.clientWidth) / 2) : 0;
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.classList.remove('pups-media-zoomed');
        this.zoomButton.textContent = 'Zoom in';
        this.zoomButton.setAttribute('aria-pressed', 'false');
        this.showActiveMedia();
        this.zoomButton.hidden = !this.querySelector('img.active');
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');


        const container = this.querySelector('[role="document"]');
        container.scrollLeft = 0;
        container.scrollTop = 0;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
